<template>
    <div class="timetable-header bg-white d-flex align-items-center p-5 mb-10" v-if="currentEvent">
        <div class="me-4 d-flex">
            <button class="btn btn-sm btn-icon btn-primary me-2" :disabled="!(currentEventIndex > 0)" @click="currentEventIndex = (currentEventIndex - 1)">
                <i class="fa fa-chevron-left fs-5"></i>
            </button>
            <button class="btn btn-sm btn-icon btn-primary me-2" :disabled="currentEventIndex >= (timetableEvents.length - 1)" @click="currentEventIndex = (currentEventIndex + 1)">
                <i class="fa fa-chevron-right fs-5"></i>
            </button>
        </div>
        <div class="max-w-300px d-flex align-items-center">
            <div class="d-flex flex-row-fluid align-items-center flex-wrap my-lg-0 me-2">
                <div class="flex-grow-1 my-lg-0 my-2 me-2">
                    <a class="text-gray-800 fw-bolder text-hover-primary fs-6">{{ currentEvent.title }}</a>
                    <div class="d-flex flex-row-fluid align-items-center flex-wrap">
                        <div class="me-6">
                            <i class="fa fa-calendar-alt me-2 text-warning fs-5"></i>
                            <span class="text-gray-800">{{ $moment(currentEvent.start).format('YYYY-MM-DD HH:mm') }}</span>
                        </div>
                    </div>
                </div>
                <div>
                    <a class="btn btn-flex btn-link" @click="eventClick(currentEvent)">
                        <i class="fa fa-arrow-right me-1"></i>
                        {{ $t('pages.timetable.upcoming.header.attendCourse') }}
                    </a>
                </div>
            </div>
        </div>
    </div>

    <TimetableModal ref="timetableModal"></TimetableModal>
</template>

<script>
import TimetableModal from "@/components/ecommerce/course/session/timetable-modal";

export default {
    name: "index",
    components: {
        TimetableModal
    },
    data(){
        return {
            timetableEvents: [],
            currentEventIndex: 0,
            showInterval: null
        }
    },
    computed: {
        currentEvent() {
            return this.timetableEvents[this.currentEventIndex] ?? null;
        }
    },
    created() {
        this.initializeUpcomingEvent();
    },
    methods: {
        initializeUpcomingEvent() {
            this.$store.dispatch('ecommerce/course/session/get', {
                filterData: {
                    'date[min]': this.$moment().startOf('month').format('YYYY-MM-DD HH:mm'),
                    'date[max]': this.$moment().endOf('month').format('YYYY-MM-DD HH:mm')
                }
            }).then((timetable) => {
                this.timetableEvents = timetable.map((data) => {
                    return {
                        id: data.id,
                        title: data.student.full_name,
                        start: data.start_date,
                        end: data.end_date
                    };
                });
                this.startShowInterval();
            });
        },
        startShowInterval(){
            if(this.showInterval) {
                clearInterval(this.showInterval);
            }

            this.showInterval = setInterval(() => {
                this.currentEventIndex = ((this.currentEventIndex >= (this.timetableEvents.length - 1)) ? 0 : (this.currentEventIndex + 1))
            }, 10000)
        },
        eventClick(event) {
            this.$refs.timetableModal.openEvent(event);
        },
    },
    beforeUnmount() {
        if(this.showInterval) {
            clearInterval(this.showInterval);
        }
    }
}
</script>

<style>
.timetable-header {
    border: 1px solid #EFF2F5;
    border-radius: 8px;
}
</style>